const variants = JSON.parse(
  document.getElementById("product-variants").innerText
);
var product = document.getElementById("producy_id").innerText;
// console.log(product, "product");
function variant_set() {
  var option1 = "",
    option2 = "",
    option3 = "",
    option4 = "",
    indx = "4";
  document
    .querySelectorAll(".swatch-element input:checked")
    .forEach((checkedInput, index) => {
      var indx = index;
      switch (index) {
        case 0:
          option1 = checkedInput.value;
          break;
        case 1:
          option2 = checkedInput.value;
          break;
        case 2:
          option3 = checkedInput.value;
          break;
        case 3:
          option4 = checkedInput.value;
          break;
      }
    });
  var title = `${option1} / ${option2} / ${option3} / ${option4}`;
  console.log(title, "title", indx);
  var image_alt = document.querySelectorAll("[data-alt]");
  variants.forEach((variant, index) => {
    // console.log(variant.title, "v", index);
    if (title.indexOf(variant.title) > -1) {
      // console.log("hit!!");

      var prce = variant.price;
      const vprce = Shopify.formatMoney(variant.price, "${{ amount }}");
      // console.log("money:", vprce);
      jQuery("#price-preview").text(vprce);
      document.querySelector(".product_id").value = variant.id;
      document.querySelector("#jump-max img").src = variant.featured_image.src;
    }

    image_alt.forEach((alt) => {
      var alt_title = alt.getAttribute("data-alt");
      // console.log(alt_title, "--->");
      if (alt_title.indexOf("_" + option1) > -1) {
        alt.classList.add("active");
      } else {
        alt.classList.remove("active");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  variant_set();
});

// console.log(variants);
document.querySelectorAll(".swatch-element input").forEach((input) => {
  input.addEventListener("change", function () {
    var option1 = "",
      option2 = "",
      option3 = "",
      option4 = "";
    document
      .querySelectorAll(".swatch-element input:checked")
      .forEach((checkedInput, index) => {
        const nameAttribute = checkedInput.getAttribute('name');
        const number = parseInt(nameAttribute.split('-')[1], 10);
        switch (number) {
          case 0:
            option1 = checkedInput.value;
            break;
          case 1:
            option2 = checkedInput.value;
            break;
          case 2:
            option3 = checkedInput.value;
            break;
          case 3:
            option4 = checkedInput.value;
            break;
        }
      });
    if (product === "Emblem") {
      var title = `${option1}`;
    } else if (product === "Tire delete") {
      var title = `${option1} / ${option2}`;
    } else {

      if (option1 == "") {
            option1 = "No - I Do Not Need a Backup Camera Design";
      }
      
      if (option2 == "") {
            option2 = "No - I'll Take My Chances Without It";
            }
      var title = `${option1} / ${option2}`;
    }
    console.log('second title: ', title);
    variant_set();
    variants.forEach((variant, index) => {
      console.log(variant.title, "tit");
      if (variant.title.includes(title)) {
        var prce = variant.price;
        vprce = Shopify.formatMoney(prce, "${{ amount }}");
        console.log(
          index,
          "moneys:",
          Shopify.formatMoney(vprce, "${{ amount }}")
        );
        jQuery("#price-preview").text(vprce);
      }
    });
  });
});

var width;
document.querySelector(".leftArrow").addEventListener("click", function () {
  console.log("left");
  var sliderImages = document.querySelector(".new-thumb img");
  width = sliderImages.width;
  console.log(width);
  document.getElementById("jump-thumbs").scrollLeft += width + 10;
});
document.querySelector(".rightArrow").addEventListener("click", function () {
  var sliderImages = document.querySelector(".new-thumb img");
  width = sliderImages.width;
  console.log(width);
  document.getElementById("jump-thumbs").scrollLeft -= width + 20;
});
//
